// extracted by mini-css-extract-plugin
module.exports = {"modal":"styles_modal__PHc10","content":"styles_content__3983f","description":"styles_description__2ZvrY"};